import React, { useEffect, useState } from 'react'
import { Container, Typography, Box, Button, Divider, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getBeneficiaryBenefits } from './APIs/action';
const AvailableBenefits = () => {
    const navigate = useNavigate();
    const [ avaialableBenefits, setAvailableBenfits ] = useState('');
    const getAvaialableBenefits = async () => {
        const { data, error, message } = await getBeneficiaryBenefits();
        if (!error) {
          const allowedBenefits = [
            "Life Insurance",
            "Medical Insurance",
            "Staff Insurance",
            "Shop Insurance",
          ];
          const filteredBenefits = data.filter(benefit =>
            allowedBenefits.includes(benefit)
          );
          setAvailableBenfits(filteredBenefits);
        } else {
          toast.error(message)
        }   
    };
    useEffect(() => {
        getAvaialableBenefits();
    }, []);
    return (
        <>
            <Container
                maxWidth='true'
                sx={{ pt: '5rem' , height: window.innerHeight, overflowY: 'auto' }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant='h4'>Available Benefits</Typography>
                </Box>
                <Divider sx={{ mt: '1rem', mb: '2rem' }} />
                <Grid container spacing={2}>
                    {avaialableBenefits && avaialableBenefits.length > 0 ? (
                        avaialableBenefits.map((benefit, index) => (
                            <Grid item xs={12} md={6}>
                                <Box sx={{ 
                                    display: { sm: 'flex' },
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '1rem',
                                    border: 1,
                                    borderColor: '#fdfdfd',
                                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px', 
                                    marginBottom: {xs: 2 , md:2},
                                }}
                                >
                                    <Typography sx={{ 
                                        fontSize:{ xs: '1rem', sm: '1.2rem'},
                                        marginBottom: { xs: 1 , md: 0 },
                                    }}>{benefit}</Typography>
                                    <Button
                                        variant='outlined'
                                        color='primary'
                                        onClick={() =>
                                            navigate('/my-benefits/add-beneficiary', {
                                                state: { benefit: true, data: benefit },
                                            })
                                        }
                                    >
                                    Add Beneficiary
                                    </Button>
                                </Box>
                            </Grid>
                        ))
                        ) : (
                            <Typography>No available benefits</Typography> 
                        )
                    }
                </Grid>
            </Container>
        </>
    )
}

export default AvailableBenefits
